import { render, staticRenderFns } from "./QuesText.vue?vue&type=template&id=c3647974&scoped=true&"
import script from "./QuesText.vue?vue&type=script&lang=js&"
export * from "./QuesText.vue?vue&type=script&lang=js&"
import style0 from "./QuesText.vue?vue&type=style&index=0&id=c3647974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3647974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCol,VFileInput,VRow,VTextField,VTextarea})
